import { useState } from 'react'
import { createModel } from 'hox'
import { useSessionStorageState } from "ahooks";
import { useGlobalModel } from "@/model/globalModel";
import { homeService } from "./HomeService";
import {
  StatisticsSearchFields,
  StatisticsFields, ScheduleFields,
  TurnoverReceiptFields, ReceiptPaymentFields,
  TradeAmountTodayFields, TradeAmountMonthFields,
  InvoiceInfoFields, InventoryRatioFields
} from "./HomeTypes";
import moment from 'moment';
import { convertRes2Blob } from '@/utils/exportFile';

export const HomeModel = createModel(function () {

  interface INavOptions {
    id: string
    path: string
    name: string
    url: string
    icon: string
  }

  const iconOptions: INavOptions[] = [
    { 'id': '01', 'path': '2-1', 'name': '客户账户总览', 'url': '/account/customer', 'icon': 'icon-kehuzhanghuzonglan' },
    { 'id': '02', 'path': '2-2', 'name': '供应商总览', 'url': '/account/supplier', 'icon': 'icon-gongyingshangzhanghuzonglan' },
    { 'id': '03', 'path': '2-3', 'name': '客户账户管理', 'url': '/account/customerManage', 'icon': 'icon-kehuzhanghuzonglan' },
    { 'id': '04', 'path': '2-4', 'name': '供应商管理', 'url': '/account/supplierManage', 'icon': 'icon-gongyingshangzhanghuguanli' },
    { 'id': '05', 'path': '2-5', 'name': '客户优惠单', 'url': '/account/customerDiscount', 'icon': 'icon-kehuyouhuidan' },
    { 'id': '06', 'path': '2-6', 'name': '内部账户管理', 'url': '/account/internal/detail', 'icon': 'icon-neibuzhanghuguanli' },
    { 'id': '07', 'path': '3-1', 'name': '客户账单管理', 'url': '/bill/customer', 'icon': 'icon-kehuzhangdanguanli' },
    { 'id': '08', 'path': '3-2', 'name': '供应商账单', 'url': '/bill/supplier', 'icon': 'icon-gongyingshangzhangdanguanli' },
    { 'id': '09', 'path': '3-3', 'name': '账单创建', 'url': '/bill/create', 'icon': 'icon-zhangdanchuangjian' },
    { 'id': '10', 'path': '3-4', 'name': '内部账单管理', 'url': '/bill/internal', 'icon': 'icon-neibuzhangdanguanli' },
    { 'id': '11', 'path': '5-1', 'name': '现金收款', 'url': '/cash/collect', 'icon': 'icon-xianjinshoukuan' },
    { 'id': '12', 'path': '5-2', 'name': '现金付款', 'url': '/cash/pay', 'icon': 'icon-xianjinfukuan' },
    { 'id': '13', 'path': '6-1', 'name': '库存统计', 'url': '/inventory/statistics', 'icon': 'icon-kucuntongji' },
    { 'id': '14', 'path': '8-1', 'name': '应用系统管理', 'url': '/base/app', 'icon': 'icon-yingyongxitongguanli' },
    { 'id': '15', 'path': '8-2', 'name': '组织机构管理', 'url': '/base/org', 'icon': 'icon-zuzhijigouguanli' },
    { 'id': '16', 'path': '8-3', 'name': '经营实体管理', 'url': '/base/be', 'icon': 'icon-jingyingshitiguanli' },
    { 'id': '17', 'path': '8-4', 'name': '数据字典管理', 'url': '/base/dict', 'icon': 'icon-shujuzidianguanli' },
    { 'id': '18', 'path': '8-5', 'name': '客户信息管理', 'url': '/base/customer', 'icon': 'icon-kehuxinxiguanli' },
    { 'id': '19', 'path': '8-6', 'name': '供应商信息', 'url': '/base/supplier', 'icon': 'icon-gongyingshangxinxiguanli' },
    { 'id': '20', 'path': '8-7', 'name': '仓库管理', 'url': '/base/warehouse', 'icon': 'icon-cangkuguanli' },
    { 'id': '21', 'path': '8-8', 'name': '系统配置管理', 'url': '/base/setting', 'icon': 'icon-xitongpeizhiguanli' },
    { 'id': '22', 'path': '8-9', 'name': '门店管理', 'url': '/base/shop', 'icon': 'icon-mendianguanli' },
    { 'id': '23', 'path': '8-10', 'name': '物料管理', 'url': '/base/materiel', 'icon': 'icon-wuliaoguanli' },
    { 'id': '24', 'path': '8-11', 'name': '内部核算单位', 'url': '/base/acctUnit', 'icon': 'icon-neibuhesuandanwei' },
    { 'id': '25', 'path': '9-1', 'name': '销售报表', 'url': '/statistic/sale', 'icon': 'icon-xiaoshoubaobiao' },
    { 'id': '26', 'path': '9-2', 'name': '采购报表', 'url': '/statistic/purchase', 'icon': 'icon-caigoubaobiao' },
    { 'id': '27', 'path': '9-3', 'name': '应收报表', 'url': '/statistic/receivable', 'icon': 'icon-yingshoubaobiao' },
    { 'id': '28', 'path': '9-4', 'name': '应付报表', 'url': '/statistic/payable', 'icon': 'icon-yingfubaobiao' },
    { 'id': '29', 'path': '9-5', 'name': '全量单据', 'url': '/statistic/fullorder', 'icon': 'icon-quanliangdanju' },
    { 'id': '30', 'path': '9-6', 'name': '充值记录总览', 'url': '/bill/rechargeLog', 'icon': 'icon-chongzhijiluzonglan' },
    { 'id': '30', 'path': '9-7', 'name': '调额记录总览', 'url': '/bill/adjustAmountLog', 'icon': 'icon-chongzhijiluzonglan' },
    { 'id': '31', 'path': '13-1', 'name': '异常挂账', 'url': '/monitoring/payment', 'icon': 'icon-yichangguazhang' },
    { 'id': '32', 'path': '13-2', 'name': '剩余金额差异', 'url': '/monitoring/remaining', 'icon': 'icon-shengyujinechayi' },
    { 'id': '33', 'path': '13-1', 'name': '客户发票管理', 'url': '/invoice/manage', 'icon': 'icon-kehufapiaoguanli' },
    { 'id': '34', 'path': '14-2', 'name': '单据发票列表', 'url': '/invoice/record', 'icon': 'icon-danjufapiaoliebiao' }
  ]
  const { user: { shopId, shopCode, userCode }, userBranch, isAdmin } = useGlobalModel();

  //请求时间
  const [requestTime, setRequestTime] = useState<string>();
  //开始时间、结束时间
  const [startTime, setStartTime] = useState<string>("");
  const [endTime, setEndTime] = useState<string>("");
  //统计数据
  const [statistics, setStatistics] = useState<StatisticsFields>();
  const [inventoryAmount, setInventoryAmount] = useState<number>(0);
  //统计数据
  const [schedule, setSchedule] = useState<ScheduleFields>();
  //管理版-营业额、应收金额统计
  const [saleLineData, setSaleLineData] = useState<TurnoverReceiptFields[]>([]);
  const [salePieData, setSalePieData] = useState<TurnoverReceiptFields[]>([]);
  const [turnoverReceiptAmountType, setTurnoverReceiptAmountType] = useState<number>(1);
  //管理版-收付款金额根据门店统计
  const [payBarData, setPayBarData] = useState<ReceiptPaymentFields[]>([]);
  const [payPieData, setPayPieData] = useState<ReceiptPaymentFields[]>([]);
  const [receiptPaymentAmountType, setReceiptPaymentAmountType] = useState<number>(1);

  //统计版-图表数据
  const [turnoverPieData, setTurnoverPieData] = useState<TradeAmountTodayFields[]>([]);
  const [tradeLineData, setTradeLineData] = useState<TradeAmountMonthFields[]>([]);
  const [inventoryPieData, setInventoryPieData] = useState<InventoryRatioFields[]>([]);
  const [InvoiceBarData, setInvoiceBarData] = useState<InvoiceInfoFields[]>([]);

  //快捷方式弹窗
  const [shortcutVisible, setShortcutVisible] = useState<boolean>(false);
  const [checkValues, setCheckValues] = useState<any[]>([])
  const [noCheckValues, setNoCheckValues] = useState<any[]>([])
  const [navOptions, setNavOptions] = useState<INavOptions[]>(iconOptions)
  const [optionsList, setOptionsList] = useState<any[]>([])
  const [exportLoading, setExportLoading] = useState(false)

  const loadShortcut = async () => {
    setOptionsList(iconOptions)

    let { retData } = await homeService.set({ "userCode": userCode ?? "" })
    setCheckValues(retData)
    let newData = retData.map((item) => item.url)
    let newList = navOptions.filter((item) => !newData.includes(item.url));
    setNoCheckValues(newList)
  }

  const loadAll = (param: StatisticsSearchFields) => {
    loadStatistics(param);
    querySchedule();
    loadShortcut();
  }

  const loadStatistics = (param: StatisticsSearchFields) => {
    queryStatistics(param);
    queryInventoryAmount();


    if (isAdmin) {
      turnoverReceiptAmount(param);
      receiptPaymentAmount(param);
    }
    else {
      tradeAmountToday();
      tradeAmountMonth();
      invoiceInfo();
      inventoryRatio();
    }
  }

  //首页统计数据
  const queryStatistics = async (param: StatisticsSearchFields) => {
    const searchParams = {
      "shopCode": shopCode,
      "startTime": startTime ?? "",
      "endTime": endTime ?? "",
      ...param
    }
    let { retData } = await homeService.homePageStatistics(searchParams);
    setStatistics(retData);

    setRequestTime("数据统计截止: " + moment().format('YYYY/MM/DD HH:mm:ss'));
  }

  //首页统计数据-库存金额
  const queryInventoryAmount = async () => {
    // let { retData } = await homeService.statistics({ "shopId": shopId, "userBranch": userBranch });
    // setInventoryAmount(retData?.totalInventoryAmount ?? (retData?.stockAmount ?? 0));
    setInventoryAmount(0);
  }

  //首页待办事项统计
  const querySchedule = async () => {
    let { retData } = await homeService.homePageSchedule({ "shopCode": shopCode });
    setSchedule(retData);
  }

  //管理版-营业额、应收金额统计 1门店 2实体
  const turnoverReceiptAmount = async (param: StatisticsSearchFields) => {
    const searchParams = {
      "type": turnoverReceiptAmountType ?? 1,
      "startTime": startTime ?? "",
      "endTime": endTime ?? "",
      ...param
    }
    let { retData } = await homeService.turnoverReceiptAmount(searchParams);
    setSaleLineData(retData.filter(e => e.name != "ALL"));
    setSalePieData(retData.filter(e => e.name == "ALL"));
  }

  //管理版-收付款金额统计 1门店 2实体
  const receiptPaymentAmount = async (param: StatisticsSearchFields) => {
    const searchParams = {
      "type": receiptPaymentAmountType ?? 1,
      "startTime": startTime ?? "",
      "endTime": endTime ?? "",
      ...param
    }
    let { retData } = await homeService.receiptPayment(searchParams);
    setPayBarData(retData.filter(e => e.name != "ALL"));
    setPayPieData(retData.filter(e => e.name == "ALL"));
  }

  //管理版-当日营业额
  const tradeAmountToday = async () => {
    let { retData } = await homeService.homePageTradeAmountToday({ "shopCode": shopCode });
    setTurnoverPieData(retData);
  }

  //管理版-营业额、应收金额根据按月统计
  const tradeAmountMonth = async () => {
    let { retData } = await homeService.homePageTradeAmountMonth({ "shopCode": shopCode });
    setTradeLineData(retData);
  }

  //管理版-发票信息统计
  const invoiceInfo = async () => {
    let { retData } = await homeService.homePageInvoiceInfo({ "shopCode": shopCode });
    setInvoiceBarData(retData);
  }

  //管理版-库存占比
  const inventoryRatio = async () => {
    let { retData } = await homeService.homePageInventoryRatio({ "shopCode": shopCode });
    setInventoryPieData(retData);
  }

  const setUpdate = async () => {
    let newData = checkValues.map((item) => item.url);
    let newNavOptions = navOptions
      .filter((item) => newData.includes(item.url))
      .map((item1) => {
        let { url, icon, name, path } = item1
        return {
          path: path,
          name: name,
          url: url,
          userCode: userCode,
          icon: icon,
        }
      })
    let { retData } = await homeService.setUpdate({ userCode: userCode, details: newNavOptions })

    retData && loadShortcut()
    return retData
  }
  //导出

  const exportAmountList = async () => {
    setExportLoading(true)
    try {
      let result = await homeService.export(shopCode);
      convertRes2Blob(result);
      setExportLoading(false)
    } catch {
      setExportLoading(false)
    }
  }


  return {
    loadAll, loadStatistics,
    loadShortcut,
    requestTime,
    startTime, setStartTime,
    endTime, setEndTime,
    statistics, inventoryAmount, schedule,
    turnoverReceiptAmount, turnoverReceiptAmountType, setTurnoverReceiptAmountType,
    saleLineData, salePieData,
    receiptPaymentAmount, receiptPaymentAmountType, setReceiptPaymentAmountType,
    payBarData, payPieData,
    turnoverPieData, tradeLineData, inventoryPieData, InvoiceBarData,
    shortcutVisible, setShortcutVisible,
    noCheckValues, checkValues, setNoCheckValues, setCheckValues,
    navOptions, setNavOptions, optionsList, setUpdate, exportAmountList, exportLoading
  }

});